export default {
  "track": "_track_17osg_1",
  "upgrade": "_upgrade_17osg_26",
  "input": "_input_17osg_43",
  "thumb": "_thumb_17osg_55",
  "rotate": "_rotate_17osg_1"
};import "ni:sha-256;La8j_PKshipHRpRxW2HyUeDnHlR4JAMbCPnfTQkSyco";